import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import Navigation from "@/components/Navigation";
import AboutHero from "@/components/about/AboutHero";
import BrandPhilosophy from "@/components/about/BrandPhilosophy";
import FounderStory from "@/components/about/FounderStory";
import WhatWeOffer from "@/components/about/WhatWeOffer";
import VisionMission from "@/components/about/VisionMission";
import FAQ from "@/components/about/FAQ";
import AboutCTA from "@/components/about/AboutCTA";
import Footer from "@/components/Footer";
import { organizationSchema, breadcrumbSchema } from "@/lib/seoSchemas";

const About = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a section to scroll to from navigation state
    const state = location.state as { scrollTo?: string };
    if (state?.scrollTo) {
      // Small delay to ensure all components are rendered
      setTimeout(() => {
        const element = document.getElementById(state.scrollTo);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);

  const aboutKeywords = [
    "Cittasya",
    "Yoga Nidra for Mental Well-being",
    "ancient yoga practices",
    "spiritual wellness",
    "deep relaxation practice",
    "enhanced self-awareness",
    "mental wellness",
    "emotional wellness",
    "founder story",
    "yoga philosophy",
    "mind-body connection",
    "holistic wellness",
  ];

  const aboutSchema = {
    "@context": "https://schema.org",
    "@graph": [
      organizationSchema,
      breadcrumbSchema([
        { name: "Home", url: "https://cittasya.com/" },
        { name: "About", url: "https://cittasya.com/about" },
      ]),
    ],
  };

  return (
    <div className="min-h-screen bg-cloud-white">
      <SEO
        title="About Cittasya® - Yoga Nidra Philosophy & Founder Story | Mental Wellness Journey"
        description="Discover the story behind Cittasya® and our mission to bring Yoga Nidra for mental well-being to everyone. Learn about our philosophy, founder's journey, and commitment to deep relaxation practice and enhanced self-awareness."
        keywords={aboutKeywords}
        url="https://cittasya.com/about"
        image="https://cittasya.com/founder.jpg"
        schema={aboutSchema}
      />
      <Navigation />
      <AboutHero />
      <BrandPhilosophy />
      <FounderStory />
      <WhatWeOffer />
      {/* <VisionMission /> */}
      <FAQ />
      <AboutCTA />
      <Footer />
    </div>
  );
};

export default About;
